var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import getTranslation from '../../../strings/i18n';
import { RenderIf } from 'syf-component-library/ui/atoms';
import Viewport from 'syf-component-library/ui/templates/Viewport';
import { manageDisputesProps } from '../../../const/analytics/manage-disputes';
import { StyledSecondaryButton } from '../../../styles/buttons';
import { StyledNav, StyledNavbar } from './subcomponents';
import ActivityTab from './tab';
var Navbar = function (_a) {
    var handleTab = _a.handleTab, tab = _a.tab, disputesLinkEnabled = _a.disputesLinkEnabled, handleNavigate = _a.handleNavigate;
    var t = getTranslation().t;
    var features = ['activity'];
    var handleTabClick = function (event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        handleTab(event.currentTarget.id);
    };
    return (_jsxs(StyledNavbar, { role: "tablist", justifyContent: "space-between", children: [_jsx(StyledNav, { children: features.map(function (tabId) { return (_jsx(ActivityTab, { activeTab: tab, onClick: handleTabClick, tabId: tabId }, tabId)); }) }), _jsx(RenderIf, { condition: disputesLinkEnabled, children: _jsx(Viewport.Desktop, { children: _jsx(StyledSecondaryButton, __assign({ fontSize: "root", onClick: function () { return handleNavigate === null || handleNavigate === void 0 ? void 0 : handleNavigate('disputes'); } }, manageDisputesProps, { children: t('activity.manageDisputesButton') })) }) })] }));
};
export default Navbar;
//# sourceMappingURL=index.js.map